import { ChangeEvent, FC, useState } from 'react';
import styled from 'styled-components';
import { configuration } from '../../services/Measurement';

const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
`;

const Toggle = styled.div`
  position: relative;
  margin-right: 1rem;
`;

const Radio = styled.input(({ theme }) => {
  const { color, type, shadow } = theme;

  return `
    position: absolute;
    left: -9999px;
    top: 0;

    & + label {
      position: relative;
      font-size: ${type.size.small};
      color: ${color.grayscale[0]};
      padding: 11.5px 16px;
      border-radius: 51px;
      border: 1px solid ${color.grayscale[700]};
      cursor: pointer;
      margin-bottom: 0;

      &:hover {
        background-color: ${color.grayscale[1000]};
      }
    }

    &:checked + label {
      cursor: default;
      background-color: ${color.grayscale[700]};
      box-shadow: ${shadow.dialog};
    }

    &:focus-visible + label {
      outline: 2px auto -webkit-focus-ring-color;
    }
  `;
});

export interface IDateToggle {
  callback: (value: string) => void;
  selected: string;
  className?: string;
}

const DateToggle: FC<IDateToggle> = ({ callback, selected, className }) => {
  const { dates } = configuration;
  const [active, setActive] = useState(selected || dates.ALL.value);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    setActive(value);
    callback(value);
  };

  const radioLoop = (Object.keys(dates) as Array<keyof typeof dates>).map((key) => {
    const { label, value } = dates[key];

    return value !== '1' ? (
      <Toggle key={value}>
        <Radio
          type="radio"
          id={`dateToggle-${value}`}
          name="dateToggle"
          value={value}
          checked={active === value}
          onChange={handleChange}
        />
        <label htmlFor={`dateToggle-${value}`}>{label}</label>
      </Toggle>
    ) : (
      true
    );
  });

  return <Container className={className}>{radioLoop}</Container>;
};

export default DateToggle;
